import MainApp from './MainApp.svelte';

const app = new MainApp({
	target: document.body,
});

export default app;